import BaseSpin, { SpinProps as BaseSpinProps } from 'antd/lib/spin'

export interface SpinProps extends BaseSpinProps {
  children?: JSX.Element
}

export const Spin = (props: SpinProps): JSX.Element => (
  <>
    <BaseSpin {...props} />
  </>
)

export default Spin
